@if (person$ | async; as person) {
    <div class="link-person-contents-directive">
        <div class="d-flex">
            <adapt-person-image [person]="person"
                                [disabled]="person.activeState !== ActiveState.Active"></adapt-person-image>
            <div class="ms-2">
                @if (isStakeholderManager$ | async) {
                    <h3>{{ person.fullName }}</h3>
                    <p>This person is an adapt team member</p>
                } @else {
                    <h3>
                        @if (profileUrl$ | async; as profileUrl) {
                            <a [routerLink]="profileUrl">
                                {{ person.fullName }}
                            </a>
                        } @else {
                            <a>
                                {{ person.fullName }}
                            </a>
                        }
                        @if (person && person.activeText) {
                            <small>({{ person.activeText }})</small>
                        }
                    </h3>
                    <p>{{ positionName$ | async }}</p>
                }
            </div>
        </div>
        @if (!(isStakeholderManager$ | async)) {
            <div class="mt-2">
                @if (hasPermissionToReadContactDetails$ | async) {
                    <ul class="mb-0">
                        @for (detail of contactDetails$ | async; track detail) {
                            <li>
                                <adapt-contact-detail [detail]="detail"></adapt-contact-detail>
                            </li>
                        }
                    </ul>
                }
            </div>
        }
    </div>
}
